export default {
    patchNote: "Примечания к патчу",
}